module.exports = __webpack_public_path__ + "img/keyboard-arrow-previous.190b8a68.svg";